module.exports = __webpack_public_path__ + "static/media/cx.cb38047b.svg";